/** @jsxImportSource @emotion/react */
import closeImg from '../../../assets/icons/whiteCloseX.svg';
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { Column, Row } from '../../../layout/flexbox';
import { FADE_IN_ANIMATION } from '../../../styles/animations';
import { CLICKABLE, MediumText, UNSELECTABLE_TEXT } from '../../../styles/styles';
import { isNilOrEmpty } from '../../../language/module';

const closeImageCss = css`
  width: 20px;
  height: 20px;
  padding: 15px 15px 0; /* Padding to increase click-area */
  ${CLICKABLE};
  ${UNSELECTABLE_TEXT};
`;

const boxedMessageImageCss = css`
  width: 30px;
  height: 30px;
  margin-right: 5px;
  margin-top: 0;
  flex-basis: 30px;
  flex-shrink: 0;
`;

const boxedMessageCss = (color) => css`
  ${MediumText};
  margin-left: 5px;
  margin-top: 6px;
  color: ${color};
  white-space: pre-line;
  flex-grow: 1;
`;


/**
 * BoxedMessage: a component that shows a message in a box with a background color, left-hand image
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class BoxedMessage extends React.PureComponent<{
  backgroundColor: string;
  textColor: string;
  message: string | React.ReactNode;
  onClose?: () => void;
  image?: string;
  imgAlt?: string;
  rootCss?: SerializedStyles;
}> {
  public render = () => <Column alignItems={'flex-end'}
                                rootCss={css`
                                  background-color: ${this.props.backgroundColor};

                                  ${FADE_IN_ANIMATION};

                                  ${this.props.rootCss};
                                `}>
    { // Close Button
      !isNilOrEmpty(this.props.onClose) && <img alt='Close'
                                                title='close'
                                                src={closeImg}
                                                onClick={this.props.onClose}
                                                css={closeImageCss}/>
    }
    <Row alignItems='flex-start'
         rootCss={css`
           align-self: stretch;
           padding: 0 15px;
           ${isNilOrEmpty(this.props.onClose) ? 'padding-top: 10px;' : ''};
         `}>
      <img alt={this.props.imgAlt}
           src={this.props.image}
           css={boxedMessageImageCss}/>
      <p css={boxedMessageCss(this.props.textColor)}>{this.props.message}</p>
    </Row>
  </Column>;
}
